module.exports = "/_next/static/images/PlanFeatures-cde3272cf85ba7c8d5f44dfc75237426.webp";